import * as ev from '../constants/DOMEvents'
import * as cmn from '../common/NamaCommon';
import * as FieldType from '../constants/FieldType';
import {_showFieldInfo, getFieldStyle, showFieldInfoFor, showTooltip_} from "../login/ClientCache";
import * as KeyboardKeyCode from "../constants/KeyboardKeyCode";

export class BaseWidget {
    /**
     *
     * @param {Object} req
     */
    constructor(req) {
        /***
         * @type {namaTypes.FieldMetaData}
         */
        let fieldMetadata = req.fieldMetadata,
            owner = req.owner,
            id = req.id,
            width = req.width;

        let that = this;
        that.id = id;
        that.cellOptions = req.cellOptions;
        that.fieldMetadata = fieldMetadata;
        if (!id && fieldMetadata && fieldMetadata.fieldId)
            that.id = fieldMetadata.fieldId;
        that.owner = owner;
        // that.width = width;
        let referencePartOfGenRef = that.renderValueInRefAndGoTo && that.fieldMetadata.fieldType === FieldType.Genericreference;
        if (owner.addDataWidget && !referencePartOfGenRef)
            owner.addDataWidget(this);
        this.elementId = cmn.nextId();
    }

    /**
     *
     * @return {NamaJquery|string}
     */
    render() {
        let style = '';
        let that = this;
        let width = that.width;
        if (width && width !== -1) {
            style = "style='width:" + width + "%'";
        }
        let element = that.createElement(style);
        element.data("nc", that);
        if (that.shouldAddBlurHandler())
            element.on(ev.EVENT_BLUR, (e) => that.onBlur(e));
        element.on("contextmenu", (e) => {
            showFieldInfoFor(that.owner.entityType, that.id, that.referenceTable(), e, that.owner);
        });
        element.on("keydown", (e) => {
            if (e.keyCode === KeyboardKeyCode.F9) {
                let lineNumber = -1;
                if (that.cellOptions && that.owner.dataSource) {
                    /**
                     * {array}
                     */
                    let data = that.owner.dataSource.data();
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].id === that.cellOptions.model["id"]) {
                            lineNumber = i;
                            break;
                        }
                    }
                }
                if (that.owner && that.owner.entityType)
                    showTooltip_(that.owner.entityType, that.id, lineNumber, that.owner);
            }
        });
        return element;
    }

    referenceTable() {
        return "";
    }

    shouldAddBlurHandler() {
        return true;
    }

    afterAttach() {
        if (!(this.owner && this.owner.entityType))
            return;
        let style = getFieldStyle(this.owner.entityType, this.id);
        if (!style)
            return;

        let element = this.findElement();
        if (style.backColor)
            element.css("background-color", style.backColor);
        if (style.foreColor)
            element.css("color", style.foreColor);
        if (style.direction)
            element.css("direction", style.direction);
    }

    createElement(style) {
        return $(`<input class="full-width" type='text' ${style} id="${this.elementId}" autocomplete="off"  nid="${this.id}">`);
    }

    onBlur(e) {
        this.onEdit(this.readValueFromElement());
    }

    onEdit(newValue) {
        let that = this;
        if (newValue === that.oldValue)
            return;
        let updateErrors = true;
        if (!newValue && !that.oldValue)
            updateErrors = false;
        that.oldValue = newValue;
        let owner = that.owner;
        if (updateErrors)
            that.removeErrorMarkerAndTooltip();
        if (!owner)
            return;
        if (owner.onDataChanged)
            owner.onDataChanged(that.id, that.valueOrParsedValue(newValue), that.cellOptions, that.entityType);
    }

    valueOrParsedValue(value) {
        return this.parsedValue();
    }

    setValue(value) {
        let that = this;
        that.oldValue = value;
        that.setValueInElement(value);
    }

    setValueInElement(value) {
        this.findElement().val(value);
    }

    /**
     * @method
     * @returns {NamaJquery}
     */
    findElement() {
        return this.owner.rootElement().find("#" + this.elementId);
    }

    elementToHighlight() {
        return this.findElement().closest(".widgetContainer");
    }

    find(arg) {
        return this.owner.rootElement().find(arg);
    }
    readValueFromElement() {
        return this.findElement().val();
    }

    parsedValue() {
        return this.readValueFromElement();
    }

    setEnabled(enabled) {
        if (enabled === "Enabled" || enabled === true)
            this.findElement().removeAttr('disabled');
        else
            this.findElement().prop('disabled', true);
    }

    setVisible(visible) {
        if (visible)
            this.findElement().prop('display', '');
        else
            this.findElement().prop('display', 'none');
    }

    get isField() {
        return true;
    }

    removeErrorMarkerAndTooltip() {
        let that = this;
        that.findElement().parents().removeClass("invalidInput");
        that.findElement().parents().removeClass("k-tooltip");
    }

    focus() {
        this.findElement().focus();
    }
}